export const FIFTEEN_MINUTES = 15 * 60 * 1000;
